import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { Modal } from "@/components/common";
import styles from "./EditChecklistItemModal.module.css";
export const EditChecklistItemModal = ({ isOpen, onClose, onSave, item, }) => {
    const [itemText, setItemText] = useState("");
    useEffect(() => {
        if (isOpen && item) {
            setItemText(item.text);
        }
        else {
            setItemText("");
        }
    }, [isOpen, item]);
    const handleSubmit = (e) => {
        e.preventDefault();
        if (item && itemText.trim()) {
            onSave(item.id, itemText.trim());
            // Parent closes modal on success
        }
    };
    return (_jsx(Modal, { isOpen: isOpen && !!item, onClose: onClose, children: _jsx("form", { onSubmit: handleSubmit, children: _jsxs("div", { className: styles.modalWrapper, children: [_jsx("div", { className: styles.modalHeader, children: _jsx("h2", { className: styles.modalTitle, children: "Edit Checklist Item" }) }), _jsx("div", { className: styles.modalBody, children: _jsxs("div", { className: styles.formGroup, children: [_jsx("label", { className: styles.formLabel, children: "Item Text" }), _jsx("input", { type: "text", className: styles.textInput, value: itemText, onChange: (e) => setItemText(e.target.value), autoFocus: true })] }) }), _jsxs("div", { className: styles.modalFooter, children: [_jsx("button", { type: "button", className: styles.cancelBtn, onClick: onClose, children: "Cancel" }), _jsx("button", { type: "submit", className: styles.saveBtn, disabled: !itemText.trim(), children: "Update" })] })] }) }) }));
};
